import configureMockStore from 'redux-mock-store';
import thunk from 'redux-thunk';

jest.mock('../../global/axios', () => ({
    get: jest.fn(),
    post: jest.fn(),
    put: jest.fn(),
    patch: jest.fn(),
    delete: jest.fn(),
}));

jest.mock('form-data', () => {
    class RecordingFormData {
        constructor() {
            this.entries = [];
        }
        append(name, value) {
            this.entries.push([name, value]);
        }
        get(name) {
            const found = this.entries.find(([key]) => key === name);
            return found ? found[1] : null;
        }
    }
    return RecordingFormData;
});

import axios from '../../global/axios';
import { fetchSeriesArt, updateSeriesArt, uploadSeriesArt } from './billboard_actions';
import * as actionTypes from './actionTypes';

const mockStore = configureMockStore([thunk]);

describe('fetchSeriesArt (#482)', () => {
    beforeEach(() => {
        axios.get.mockReset();
    });

    it('dispatches start then success with the GET response', async () => {
        const details = { series_art_enabled: true, current_series_art_url: 'https://example.com/a.jpg' };
        axios.get.mockResolvedValue({ data: details });

        const store = mockStore({});
        await store.dispatch(fetchSeriesArt());

        const types = store.getActions().map(a => a.type);
        expect(types).toEqual([actionTypes.FETCH_SERIES_ART_START, actionTypes.FETCH_SERIES_ART_SUCCESS]);
        expect(store.getActions()[1].details).toEqual(details);
        expect(axios.get).toHaveBeenCalledWith('/billboard/series_art.json');
    });
});

describe('updateSeriesArt (#482)', () => {
    beforeEach(() => {
        axios.patch.mockReset();
        global.alert = jest.fn();
    });

    it('PATCHes the given attrs and dispatches success with the response', async () => {
        const details = { series_art_enabled: true };
        axios.patch.mockResolvedValue({ data: details });

        const store = mockStore({});
        await store.dispatch(updateSeriesArt({ series_art_enabled: true }));

        expect(axios.patch).toHaveBeenCalledWith('/billboard/series_art.json', { series_art_enabled: true });
        const types = store.getActions().map(a => a.type);
        expect(types).toEqual([actionTypes.UPDATE_SERIES_ART_START, actionTypes.UPDATE_SERIES_ART_SUCCESS]);
    });

    it('sends an empty manual url to clear the override', async () => {
        axios.patch.mockResolvedValue({ data: {} });
        const store = mockStore({});
        await store.dispatch(updateSeriesArt({ series_art_manual_url: '' }));
        expect(axios.patch).toHaveBeenCalledWith('/billboard/series_art.json', { series_art_manual_url: '' });
    });
});

describe('uploadSeriesArt — S3 upload then PATCH series_art (#482)', () => {
    const SIGNED_RESPONSE = {
        data: {
            key: 'billboard_uploads/uuid.png',
            AWSAccessKeyId: 'AKIA',
            policy: 'cG9saWN5',
            signature: 'c2ln',
            content_type: 'image/png',
            cache_control: 'public, max-age=31536000, immutable',
        },
    };
    const S3_XML =
        '<?xml version="1.0" encoding="UTF-8"?>' +
        '<PostResponse><Location>https://worshipkit.s3.amazonaws.com/billboard_uploads/uuid.png</Location></PostResponse>';

    beforeEach(() => {
        axios.get.mockReset();
        axios.post.mockReset();
        axios.patch.mockReset();
        global.alert = jest.fn();
        if (typeof global.crypto === 'undefined') {
            global.crypto = { randomUUID: () => 'local-uuid' };
        } else if (typeof global.crypto.randomUUID !== 'function') {
            global.crypto.randomUUID = () => 'local-uuid';
        }
    });

    it('uploads to S3 then PATCHes the resulting URL as the manual override', async () => {
        axios.post.mockImplementation((url) => {
            if (url === '/billboard/signed_urls/v2') {
                return Promise.resolve(SIGNED_RESPONSE);
            }
            if (url === 'https://worshipkit.s3.amazonaws.com') {
                return Promise.resolve({ data: S3_XML });
            }
            return Promise.resolve({ data: {} });
        });
        axios.patch.mockResolvedValue({ data: { series_art_manual_url: 'https://worshipkit.s3.amazonaws.com/billboard_uploads/uuid.png' } });

        const store = mockStore({});
        const file = { name: 'series.png', type: 'image/png' };
        store.dispatch(uploadSeriesArt(file));

        // Drain the microtask queue through signed-url -> S3 -> PATCH -> dispatch.
        for (let i = 0; i < 20 && store.getActions().length < 2; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            await Promise.resolve();
        }

        expect(axios.patch).toHaveBeenCalledWith(
            '/billboard/series_art.json',
            { series_art_manual_url: 'https://worshipkit.s3.amazonaws.com/billboard_uploads/uuid.png' }
        );

        const types = store.getActions().map(a => a.type);
        expect(types).toEqual([actionTypes.UPLOAD_SERIES_ART_START, actionTypes.UPLOAD_SERIES_ART_SUCCESS]);
    });
});
